const getReportDescription = ({
  isAppliance,
  isMixedPlan,
  description,
  descriptionForAppliance,
  descriptionForMixedPlan
}) => {
  if (isAppliance) {
    return descriptionForAppliance || description;
  } else if (isMixedPlan && descriptionForMixedPlan) {
    return descriptionForMixedPlan;
  }

  return description;
};

export default getReportDescription;
